module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_fails.js
// module id = 145
// module chunks = 2